import * as React from "react";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { TaskRequestStatus } from "../../../../../Wrap/Constants/Enums/Tasks/TaskRequestStatus";
import { RemunerationStatementInfo } from "../../../../../Wrap/Models/Models/Reports/RemunerationStatementInfo";
import { ITableConfig, Table } from "../../../../Shared/Table/Table";
import { RemunerationStatementEntityTypeMap, TaskRequestStatusMap } from "../Resource/Contents";
import { DocumentFileAction } from "../../Clients/PortfolioDashboard/Components/Document/Action/DocumentFileAction";
import { Constants } from "../../Clients/PortfolioDashboard/Components/Document/Resource/Constant";

interface IRemunerationStatementSearchResultTableProps {
    data: any;
    onPageChange: (currentPage, isShowErr) => void;
}

export const RemunerationStatementSearchResultTable = (props: IRemunerationStatementSearchResultTableProps) => {
    if (!props.data) {return null;}

    const [currentPage, setCurrentPage] = React.useState(1);

    const col: ITableConfig[] = [
        {
            title: "ID",
            key: "TaskRequestID",
        },
        {
            title: "Company/Network name",
            key: "OwnerName",
        },
        {
            title: "Report level",
            key: "RemunerationStatementEntityType",
            render: (data) => {
                return RemunerationStatementEntityTypeMap[data];
            },
        },
        {
            title: "Date generated",
            key: "DateTimeRequested",
            render: (data: Date) => {
                return JsonDateParser.getFormatDateString(new Date(data), "dd MM yyyy hh:mm:ss", true);
            },
        },
        {
            title: "Download link",
            key: "File",
            render: (data: string, row: RemunerationStatementInfo, index) => {
                return row?.TaskRequestStatus == TaskRequestStatus.Complete ? (
                    <a className="hyperlink" href="javascript:void(0);" onClick={()=> DownloadFile(row.FileName, row.TaskRequestID)}>
                        Download
                    </a>
                ) : row?.TaskRequestStatus == TaskRequestStatus.Pending ||
                  row?.TaskRequestStatus == TaskRequestStatus.Running ||
                  row?.TaskRequestStatus == TaskRequestStatus.Allocated ||
                  row?.TaskRequestStatus == TaskRequestStatus.PendingDelayed ||
                  row?.TaskRequestStatus == TaskRequestStatus.PendingHold ? (
                    <div className="pending-spinner mb-40">
                        <div className="lds-dual-ring"></div>
                        <span className="text">Pending...</span>
                    </div>
                ) : (
                    <p>{TaskRequestStatusMap[row?.TaskRequestStatus]}</p>
                );
            },
        },
    ];

    return (
        <Table
            data={props.data.PageOfResults}
            col={col}
            showEmptyMsg
            cssWrapper="mb-60"
            needPagination={{
                totalNumOfResult: props.data.TotalNumberOfResults,
                onPaginationChange: (pageIndex) => {
                    setCurrentPage(pageIndex);
                    props.onPageChange(pageIndex, false);
                },
                pageSize: 10,
                currentPage: currentPage,
            }}
        />
    );

    function DownloadFile(fileName: string, taskRequestID: number){
        DocumentFileAction.get(
            null,
            fileName,
            true,
            0,
            taskRequestID,
            null,
            (result) => {
                if (result !== null && result !== "") {
                    window.open(result);
                } else {
                    props.onPageChange(-1, true);
                }
            },
            true
        );
    }
}
